import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import { Button, Row, Input, Col, Image, Tooltip, Card, Carousel, InputNumber, Select } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'split-pane-react/esm/themes/default.css';
import { useLocation } from 'react-router-dom';

import '../../assets/styles/common.css';
import confirm_icon from '../../assets/images/confirm_icon.png';
import reload from '../../assets/images/reload_icon.png';
import reload_red from '../../assets/images/reload_icon_red.png';
import { formatDate, toDecimal, JPYs, regexExp } from '../common/Common';
import { ClientType, ParamCalType } from '../../views/common/enums.js';
import { amtEmptyStr, Customer } from '../common/Constant';
import { commonModal, confirmDisplayOldNewParamContent } from '../common/CommonModal';
import search from '../../assets/images/search.png';
import SearchAndGetCustomerData from '../common/SearchAndGetCustomerData';

dayjs.extend(customParseFormat);

const EstimateBasicInfo = forwardRef((props, ref) => {
  const [estimateBasicInfo, setEstimateBasicInfo] = useState([]);
  const [costPrice, setCostPrice] = useState([]);
  const [costPriceTotal, setCostPriceTotal] = useState([]);
  const [isReCalOldNewParam, setIsReCalOldNewParam] = useState(false);
  const [isMGrossProfitCoeff, setIsMGrossProfitCoeff] = useState(false);
  const [calBefore, setCalBefore] = useState(false);
  const { TextArea } = Input;
  const [customerModal, setCustomerModal] = useState(false);
  const [orderCoeffs, setOrderCoeffs] = useState([]);
  const [deliveryDateCoeffs, setDeliveryDateCoeffs] = useState([]);
  const [purchaseCoeffs, setPurchaseCoeffs] = useState([]);
  const [mangCoeffs, setMangCoeffs] = useState([]);
  const [setupCoeffs, setSetupCoeffs] = useState([]);
  const [surfaceTotalPrice, setSurfaceTotalPrice] = useState(0);
  const [surfaceUnitPrice, setSurfaceUnitPrice] = useState(0);
  const [proudCoeffs, setProudCoeffs] = useState([]);

  const location = useLocation();

  useEffect(() => {
    let estimateBasicInfo = JSON.parse(JSON.stringify(props.estimateBasicInfo));
    updateEstimateInfo(estimateBasicInfo);
  }, [
    props.estimateBasicInfo,
    props?.basicInfoUpdate,
    props.isReCal,
    props.estimateBasicInfo?.estimateProducts?.id,
    // props.estimateBasicInfo.estimateProducts.quantity,
    props.estimateBasicInfoChangedFlg,
  ]);

  useEffect(() => {
    if (props.parentInfoChangeFlg) {
      setCalBefore(true);
    } else {
      setCalBefore(false);
    }
  }, [props.activePartMenu, props.parentActiveTabKey, props.parentInfoChangeFlg]);

  const updateEstimateInfo = (estimateInfo) => {
    //費用合計
    let costPrices = 0;
    let costPriceTotal = 0;
    let epCustomCosts = estimateInfo?.epCustomCosts;
    let quantity = estimateInfo?.estimateProducts?.quantity;
    for (let i = 0; i < epCustomCosts?.length; i++) {
      if (epCustomCosts[i]?.isUseUnit) {
        costPriceTotal += epCustomCosts[i]?.unitPrice * quantity; // IQX_WEBEST-235
      } else {
        costPriceTotal += epCustomCosts[i]?.totalPrice;
      }
    }
    costPrices = Number.isFinite(costPriceTotal / quantity) ? costPriceTotal / quantity : 0;
    setCostPrice(costPrices);
    setCostPriceTotal(costPriceTotal);
    // 表面処理費の設定
    let iq3SurfaceUnitPrice = estimateInfo?.esIq3Info?.reduce((total, item) => {
      return total + Number(item.surfaceUnitPrice); // 板金の表面処理費単価
    }, 0);
    let iq3SurfaceTotalPrice = estimateInfo?.esIq3Info?.reduce((total, item) => {
      return total + Number(item.surfaceTotalPrice); // 板金の表面処理費合計
    }, 0);
    let totalSurfaceUnitPrice = iq3SurfaceUnitPrice;
    setSurfaceUnitPrice(totalSurfaceUnitPrice);

    let totalSurfaceTotalPrice = iq3SurfaceTotalPrice;
    setSurfaceTotalPrice(totalSurfaceTotalPrice);

    setEstimateBasicInfo(estimateInfo == undefined ? [] : estimateInfo?.estimateProducts);

    let parameters = props?.estimateBasicInfo?.estimateProducts?.calcParameters?.parameters;
    if (parameters) {
      initCompanyInfo(parameters?.company);
    }

    props?.updateEstimateBasicInfoChangedFlg(false);
  };

  const onChange = () => {};

  useImperativeHandle(ref, () => ({
    updateEstimateInfo: updateEstimateInfo,
  }));

  // 再計算ボタン押下
  const onClickReCalEstimate = (e) => {
    props.settingParametersByReCal(
      // 選択した、パラメータタイプを更新して再計算する
      ParamCalType.OldParam,
      false,
      false,
      false,
      false
    ); // IQX_WEBEST-171
    setCalBefore(false);
    props?.updateParentInfoChange(false);
  };

  // 再計算しない
  const discardConfirmCancel = () => {
    setIsReCalOldNewParam(false);
  };

  // 新パラで再計算
  const calculateWithNewParam = async () => {
    setIsReCalOldNewParam(false);
    await props.settingParametersByReCal(ParamCalType.NewParam);
    props?.updateIsRecalMaterial(true);
  };

  // 旧パラで再計算
  const calculateWithOldParam = async () => {
    setIsReCalOldNewParam(false);
    await props.settingParametersByReCal(ParamCalType.OldParam);
  };

  // 材質の情報を得る
  const getMaterialTypeIq3 = (id) => {
    let parameters = props?.estimateBasicInfo?.estimateProducts?.calcParameters?.parameters;
    let info = parameters?.materialTypeIq3?.find((item) => item?.id === id);
    return info;
  };

  /* 画面切替警告メッセージのタイトル */
  const confirmScreenChangeTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
        display: 'flex',
      }}
    >
      <Image preview={false} width={20} src={confirm_icon} style={{ marginTop: 9, marginLeft: 7 }}></Image>
      <p style={{ paddingTop: 8, paddingLeft: 10, color: 'white', margin: 0 }}>確認</p>
    </div>
  );

  /* 材料粗利係数のタイトル */
  const mGrossProfitCoeffTitle = (
    <div
      style={{
        width: 850,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
        display: 'flex',
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 10, color: 'white', margin: 0 }}>材料粗利係数</p>
    </div>
  );

  /* 材料粗利係数画面 */
  const mGrossProfitCoeffContent = (
    <>
      <div style={{ overflowY: 'auto', marginTop: 5, height: '400px' }}>
        <Row className="estimate-tab2-title-row">
          <Col style={{ width: '7%' }} className="estimate-tab2-title-col">
            No.
          </Col>
          <Col style={{ width: '30%' }} className="estimate-tab2-title-col">
            子部品図番
          </Col>
          <Col style={{ width: '30%' }} className="estimate-tab2-title-col">
            子部品名称
          </Col>
          <Col style={{ width: '20%' }} className="estimate-tab2-title-col">
            材質
          </Col>
          <Col style={{ width: '13%' }} className="estimate-tab2-title-col">
            材料粗利係数
          </Col>
        </Row>
        {props?.estimateBasicInfo?.esIq3Info?.map((iq3, index) => (
          <Row className="estimate-tab2-row">
            <Col style={{ width: '7%' }} className="cm-a-right estimate-tab2-col">
              {index + 1}
            </Col>
            <Col style={{ width: '30%' }} className="cm-a-left estimate-tab2-col">
              {iq3?.drawingNo}
            </Col>
            <Col style={{ width: '30%' }} className="cm-a-left estimate-tab2-col">
              {iq3?.name}
            </Col>
            <Col style={{ width: '20%' }} className="cm-a-left estimate-tab2-col">
              {getMaterialTypeIq3(iq3?.materialTypeIq3Id)?.name}
            </Col>
            <Col style={{ width: '13%' }} className="cm-a-right estimate-tab2-col">
              {getMaterialTypeIq3(iq3?.materialTypeIq3Id)?.info?.lossCoeff}
            </Col>
          </Row>
        ))}
      </div>
    </>
  );

  // 材料粗利係数のボタン押下
  const openMGrossProfitCoeff = () => {
    setIsMGrossProfitCoeff(true);
  };

  // 材料粗利係数画面を閉じる
  const closeMGrossProfitCoeff = () => {
    setIsMGrossProfitCoeff(false);
  };

  // 2025-05-15 数量や粗利係数などを直接左側の画面から変更できない。
  // 数量のチェック
  const checkSuuRyou = (value, isCheckZenkaku = true) => {
    let suuryou = value;
    if (regexExp.test(suuryou) && !isDigitZenkaku(suuryou)) return;
    if (isCheckZenkaku && regexExp.test(suuryou)) {
      // 全角の場合、
      suuryou = toHalfWidth(suuryou); // 半角へ変換
      if (!isDigit(suuryou)) return;
    }
    suuryou = suuryou ? Number(suuryou) : 0;
    props.onChangeEstimateProduct({
      ...props.estimateBasicInfo.estimateProducts,
      quantity: suuryou,
    });
    for (let i = 0; i < props?.estimateBasicInfo?.epCustomCosts?.length; i++) {
      if (props.estimateBasicInfo.epCustomCosts[i].isUseUnit === true) {
        props.estimateBasicInfo.epCustomCosts[i].totalPrice =
          props.estimateBasicInfo?.epCustomCosts?.[i]?.unitPrice && suuryou
            ? props?.estimateBasicInfo?.epCustomCosts?.[i]?.unitPrice * suuryou
            : 0;
      } else {
        props.estimateBasicInfo.epCustomCosts[i].unitPrice =
          props.estimateBasicInfo?.epCustomCosts?.[i]?.totalPrice && suuryou
            ? props?.estimateBasicInfo?.epCustomCosts?.[i]?.totalPrice / suuryou
            : 0;
      }
    }
    // setCustomCostLst(props.estimateBasicInfo?.epCustomCosts);
    props?.updateParentQuantityChange(true);
  };

  // 基本情報・お客様検索ボタン押下
  const getCustomerName = () => {
    setCustomerModal(true);
  };

  // 基本情報・お客様検索画面のClose「X」ボタン押下
  const closeCustomerModal = () => {
    setCustomerModal(false);
  };

  // 会社情報の初期化設定
  const initCompanyInfo = (companyInfo) => {
    let orderCoeffs = [];
    let deliDateCoeffs = [];
    let purCoeffs = [];
    let mngCoeffs = [];
    let setupCoeffs = [];
    let productCoeffs = [];
    if (companyInfo?.length > 0) {
      orderCoeffs = companyInfo?.[0]?.coeffOrders?.filter((i) => !i.isDeleted && i.isUsed);
      deliDateCoeffs = companyInfo?.[0]?.coeffDeliveryDates?.filter((i) => !i.isDeleted && i.isUsed);
      purCoeffs = companyInfo?.[0]?.coeffPurchases?.filter((i) => !i.isDeleted && i.isUsed);
      mngCoeffs = companyInfo?.[0]?.coeffManagements?.filter((i) => !i.isDeleted && i.isUsed);
      setupCoeffs = companyInfo?.[0]?.coeffSetups?.filter((i) => !i.isDeleted && i.isUsed);
      productCoeffs = companyInfo?.[0]?.coeffProducts?.filter((i) => !i.isDeleted && i.isUsed);
    }
    setPurchaseCoeffs(purCoeffs);
    setMangCoeffs(mngCoeffs);
    setOrderCoeffs(orderCoeffs);
    setDeliveryDateCoeffs(deliDateCoeffs);
    setSetupCoeffs(setupCoeffs);
    setProudCoeffs(productCoeffs);
  };

  // 2025-05-15 数量や粗利係数などを直接左側の画面から変更できない。
  // お客様一覧のOKボタン押下
  const selectedCustomerData = async (selectedCustomerData) => {
    let id = selectedCustomerData.id;
    let name = selectedCustomerData.name;
    let code = selectedCustomerData.code;
    let coeff = selectedCustomerData?.coeffClients?.find((item) => item.clientType === ClientType.Customer)?.coeff;

    let cpOtherProduct = JSON.parse(JSON.stringify(props.estimateBasicInfo.estimateProducts.otherProduct));
    if (cpOtherProduct) {
      cpOtherProduct.coeffClient = coeff;
      props.onChangeEstimateProduct({
        ...props.estimateBasicInfo.estimateProducts,
        clientId: id,
        clientName: name,
        clientCode: code,
        otherProduct: cpOtherProduct,
      });
    }
    setCustomerModal(false);
  };

  return (
    <>
      {location.pathname === '/home/:estimate.parent' ||
      location.pathname === '/home/:estimate.iq3' ||
      location.pathname === '/home/:estimate.iq5' ? (
        <div
          style={{
            backgroundColor: '#002060',
            height: '90.8vh',
            padding: 2,
            overflow: 'auto',
          }}
        >
          {/** 基本情報 */}
          <Card hoverable={false}>
            <Row align="middle">
              <Col span={5}>
                <Tooltip title="再計算" placement="top" overlayClassName="tooltip-text">
                  <a onClick={onClickReCalEstimate}>
                    <Image
                      preview={false}
                      src={calBefore ? reload_red : reload}
                      width={47}
                      style={{ marginLeft: '7px', marginTop: 0 }}
                    ></Image>
                  </a>
                </Tooltip>
              </Col>
              <Col span={19}>
                <p style={{ margin: 0, fontSize: '17px', paddingLeft: 0, wordBreak: 'break-all' }}>
                  {/** IQX_WEBEST-306 「数量別見積確認」画面上部の係数表示部の位置調整 */}
                  {estimateBasicInfo == undefined ? '' : estimateBasicInfo?.drawingNo}
                </p>
                <p style={{ margin: 0, fontSize: '16px', paddingLeft: 0, wordBreak: 'break-all' }}>
                  {/** IQX_WEBEST-306 「数量別見積確認」画面上部の係数表示部の位置調整 */}
                  {estimateBasicInfo == undefined ? '' : estimateBasicInfo?.name}
                </p>
                <p style={{ margin: 0, fontSize: '16px', paddingLeft: 0, wordBreak: 'break-all' }}>
                  {/** IQX_WEBEST-306 「数量別見積確認」画面上部の係数表示部の位置調整 */}
                  {estimateBasicInfo == undefined ? '' : estimateBasicInfo?.estimateNo}
                </p>
              </Col>
            </Row>
            {/* <Row>
            <Col span={24} style={{ textAlign: 'center' }}>
              <p style={{ margin: 0, fontSize: '16px' }}>
                {estimateBasicInfo == undefined ? '' : estimateBasicInfo?.estimateNm}
              </p>
            </Col>
          </Row> */}
            <Row
              style={{
                background: '#364d79',
                marginTop: '5px',
                borderRadius: '3px',
                padding: '3px',
              }}
            >
              <Col span={24} style={{ textAlign: 'center' }}>
                <p style={{ margin: 0, fontSize: '12px' }}>{estimateBasicInfo?.clientName}</p>
              </Col>
            </Row>
            {/** 総重量*/}
            <Row style={{ marginTop: '5px' }}>
              <Col span={8}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '3px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>総重量</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>
                        {estimateBasicInfo?.totalWeight != undefined
                          ? toDecimal(estimateBasicInfo?.totalWeight, 2) + 'kg'
                          : '0.00kg'}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={8}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '3px', marginLeft: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>総表面積</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>
                        {estimateBasicInfo?.totalSurfaceArea != undefined
                          ? toDecimal(estimateBasicInfo?.totalSurfaceArea, 2) + 'c㎡'
                          : '0.00c㎡'}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={8}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '3px', marginLeft: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>体積</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>
                        {estimateBasicInfo?.sizeX != undefined ||
                        estimateBasicInfo?.sizeY != undefined ||
                        estimateBasicInfo?.sizeZ != undefined
                          ? toDecimal(
                              Number.isFinite(
                                (estimateBasicInfo?.sizeX * estimateBasicInfo?.sizeY * estimateBasicInfo?.sizeZ) / 1000
                              )
                                ? (estimateBasicInfo?.sizeX * estimateBasicInfo?.sizeY * estimateBasicInfo?.sizeZ) /
                                    1000
                                : 0,
                              2
                            ) + '㎥'
                          : '0.00㎥'}{' '}
                        {/** IQX_WEBEST-319 体積の単位修正 */}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            {/** 作成者*/}
            <Row style={{ marginTop: '5px' }}>
              <Col span={8}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '3px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>作成者</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>{estimateBasicInfo?.creater}</p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={8}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '3px', marginLeft: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>作成日</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>{formatDate(estimateBasicInfo?.created)}</p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={8}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '3px', marginLeft: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>最終更新日</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>{formatDate(estimateBasicInfo?.modified)}</p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Card>
          {/** 見積／原価／粗利・粗利率 */}
          <Card hoverable={false} style={{ borderTop: '1px solid #ffffff' }}>
            <Row>
              {/* 2025-05-15 数量や粗利係数などを直接左側の画面から変更できない。 */}
              {/* <Col span={24} style={{ textAlign: 'center' }}>
                <p style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                  {estimateBasicInfo?.quantity == undefined ? ' 数量　0' : ' 数量　' + estimateBasicInfo?.quantity}
                </p>
              </Col> */}
              <Col span={24} style={{ textAlign: 'center' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginRight: '8px' }}>数量</label>
                <InputNumber
                  min={1}
                  value={estimateBasicInfo?.quantity || 0}
                  onChange={(value) => {
                    setEstimateBasicInfo({
                      ...estimateBasicInfo,
                      quantity: value,
                    });
                  }}
                  onBlur={() => {
                    checkSuuRyou(estimateBasicInfo?.quantity);
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: '5px' }}>
              <Col span={12}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '5px' }}>
                  <Row style={{ marginTop: '3px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>原価</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '5px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                        {estimateBasicInfo?.costUnitPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.costUnitPrice))}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '5px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                        {estimateBasicInfo?.costTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.costTotalPrice))}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={12}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '5px', marginLeft: '5px' }}>
                  <Row style={{ marginTop: '3px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>見積</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '5px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                        {estimateBasicInfo?.estimateUnitPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.estimateUnitPrice))}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '5px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                        {estimateBasicInfo?.estimateTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.estimateTotalPrice))}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row style={{ marginTop: '5px' }}>
              <Col span={12}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '5px' }}>
                  <Row style={{ marginTop: '3px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>粗利</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '5px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                        {estimateBasicInfo?.grossUnitPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.grossUnitPrice))}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '5px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                        {estimateBasicInfo?.grossTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.grossTotalPrice))}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={12}>
                <div
                  style={{
                    height: '98px',
                    background: '#364d79',
                    borderRadius: '3px',
                    padding: '5px',
                    marginLeft: '5px',
                  }}
                >
                  <Row style={{ marginTop: '3px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>粗利率</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '7px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '25px', fontWeight: '600', color: 'white' }}>
                        {estimateBasicInfo?.grossRate != undefined
                          ? parseFloat(estimateBasicInfo?.grossRate)?.toFixed(2) + '%'
                          : '0.00%'}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Card>
          {/** 原価詳細 */}
          {/* <Card hoverable={false} style={{ borderTop: '1px solid #ffffff' }}>
            <Carousel afterChange={onChange} style={{ color: 'white' }}>
              <div>
                <Row>
                  <Col span={10}>
                    <div style={{ background: '#364d79', borderRadius: '3px', padding: '10px' }}>
                      <Row>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>材料原価</p>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>
                            {(estimateBasicInfo?.materialCostUnitPrice &&
                            Number(props.estimateBasicInfo?.estimateProducts?.quantity)
                              ? JPYs.format(
                                  Math.round(
                                    estimateBasicInfo?.materialCostTotalPrice /
                                      Number(props.estimateBasicInfo?.estimateProducts?.quantity)
                                  )
                                )
                              : amtEmptyStr) + '-'}
                          </p>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>
                            {estimateBasicInfo?.materialCostTotalPrice == undefined
                              ? amtEmptyStr
                              : JPYs.format(Math.round(estimateBasicInfo?.materialCostTotalPrice)) + '-'}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col span={10}>
                    <div style={{ background: '#364d79', borderRadius: '3px', padding: '10px', marginLeft: '5px' }}>
                      <Row>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>製造原価</p>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>
                            {estimateBasicInfo?.manufacturingCostTotalPrice == undefined
                              ? amtEmptyStr
                              : JPYs.format(
                                  Math.round(
                                    Number.isFinite(
                                      estimateBasicInfo?.manufacturingCostTotalPrice / estimateBasicInfo?.quantity
                                    )
                                      ? estimateBasicInfo?.manufacturingCostTotalPrice / estimateBasicInfo?.quantity
                                      : 0
                                  )
                                ) + '-'}
                          </p>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>
                            {estimateBasicInfo?.manufacturingCostTotalPrice == undefined
                              ? amtEmptyStr
                              : JPYs.format(Math.round(estimateBasicInfo?.manufacturingCostTotalPrice)) + '-'}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
              <div>
                <Row>
                  <Col span={10}>
                    <div style={{ background: '#364d79', borderRadius: '3px', padding: '10px' }}>
                      <Row>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>購入品</p>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>
                            {estimateBasicInfo?.purchaseUnitPrice == undefined
                              ? amtEmptyStr
                              : JPYs.format(Math.round(estimateBasicInfo?.purchaseUnitPrice)) + '-'}
                          </p>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>
                            {estimateBasicInfo?.purchaseTotalPrice == undefined
                              ? amtEmptyStr
                              : JPYs.format(Math.round(estimateBasicInfo?.purchaseTotalPrice)) + '-'}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col span={10}>
                    <div style={{ background: '#364d79', borderRadius: '3px', padding: '10px', marginLeft: '5px' }}>
                      <Row>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>費用</p>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>
                            {costPrice == undefined ? amtEmptyStr : JPYs.format(Math.round(costPrice)) + '-'}
                          </p>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '10px' }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}>
                            {costPriceTotal == undefined ? amtEmptyStr : JPYs.format(Math.round(costPriceTotal)) + '-'}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </Carousel>
          </Card> */}
          {/** 2025-06-27 IQX_WEBEST-428 表示の仕方を変更してほしい */}
          <Card hoverable={false} style={{ borderTop: '1px solid #ffffff' }}>
            <Row gutter={[8, 8]}>
              {/** 材料原価 */}
              <Col span={12}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>材料原価</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {(estimateBasicInfo?.materialCostUnitPrice &&
                        Number(props.estimateBasicInfo?.estimateProducts?.quantity)
                          ? JPYs.format(
                              Math.round(
                                estimateBasicInfo?.materialCostTotalPrice /
                                  Number(props.estimateBasicInfo?.estimateProducts?.quantity)
                              )
                            )
                          : amtEmptyStr) + '-'}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {estimateBasicInfo?.materialCostTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.materialCostTotalPrice)) + '-'}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              {/** 製造原価 */}
              <Col span={12}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>製造原価</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {estimateBasicInfo?.manufacturingCostTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(
                              Math.round(
                                Number.isFinite(
                                  estimateBasicInfo?.manufacturingCostTotalPrice / estimateBasicInfo?.quantity
                                )
                                  ? estimateBasicInfo?.manufacturingCostTotalPrice / estimateBasicInfo?.quantity
                                  : 0
                              )
                            ) + '-'}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {estimateBasicInfo?.manufacturingCostTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.manufacturingCostTotalPrice)) + '-'}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              {/** 購入品 */}
              <Col span={12}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>購入品</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {estimateBasicInfo?.purchaseUnitPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.purchaseUnitPrice)) + '-'}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {estimateBasicInfo?.purchaseTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.purchaseTotalPrice)) + '-'}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              {/** 表面処理費 */}
              <Col span={12}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>表面処理</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {surfaceUnitPrice == undefined ? amtEmptyStr : JPYs.format(Math.round(surfaceUnitPrice)) + '-'}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {surfaceTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(surfaceTotalPrice)) + '-'}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              {/** 費用 */}
              <Col span={12}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>費用</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {costPrice == undefined ? amtEmptyStr : JPYs.format(Math.round(costPrice)) + '-'}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {costPriceTotal == undefined ? amtEmptyStr : JPYs.format(Math.round(costPriceTotal)) + '-'}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              {/** 管理 */}
              <Col span={12}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '5px' }}>
                  <Row>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '12px' }}>管理</p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {estimateBasicInfo?.managementFeeTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.managementFeeTotalPrice)) + '-'}
                      </p>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                      <p style={{ margin: 0, fontSize: '18px' }}>
                        {estimateBasicInfo?.managementFeeTotalPrice == undefined
                          ? amtEmptyStr
                          : JPYs.format(Math.round(estimateBasicInfo?.managementFeeTotalPrice)) + '-'}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Card>

          {/** 係数 */}
          <Card hoverable={false} style={{ borderTop: '1px solid #ffffff' }}>
            {/* 2025-05-19 数量や粗利係数などを直接左側の画面から変更できない。 */}
            <Row>
              <Col span={24}>
                <div style={{ background: '#364d79', borderRadius: '3px', padding: '3px' }}>
                  {/* 2025-05-20 数量や粗利係数などを直接左側の画面から変更できない。 */}
                  <Row align="middle">
                    <Col span={7}>
                      <p style={{ margin: 0, fontSize: '12px', paddingLeft: '10px' }}>取引先係数</p>
                    </Col>
                    <Col
                      span={12}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: '5px',
                        paddingRight: '10px',
                      }}
                    >
                      <Input
                        style={{ padding: 5, backgroundClip: 'text', color: 'white', flex: 1 }}
                        className="input-non-editable"
                        name="clientName"
                        id="clientName"
                        type="text"
                        value={estimateBasicInfo?.clientName}
                      />
                      <a onClick={getCustomerName}>
                        <Image
                          preview={false}
                          width={20}
                          height={20}
                          src={search}
                          style={{ marginBottom: '2px', filter: 'invert(1) brightness(2)' }}
                        />
                      </a>
                    </Col>
                    <Col span={5}>
                      <Input
                        style={{ padding: 5, marginLeft: 5, width: '94%', backgroundClip: 'text', color: 'white' }}
                        className={'input-non-editable'}
                        name="customerCoefficient"
                        id="customerCoefficient"
                        type="text"
                        value={toDecimal(estimateBasicInfo?.otherProduct?.coeffClient, 2)}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: '5px' }}>
              <Col span={24}>
                <div
                  style={{
                    background: '#364d79',
                    borderRadius: '3px',
                    padding: '3px',
                  }}
                >
                  <Row align="middle">
                    <Col span={7}>
                      <p style={{ margin: 0, fontSize: '12px', paddingLeft: '10px' }}>管理費係数</p>
                    </Col>
                    <Col span={12}>
                      <div style={{ display: 'flex' }}>
                        {mangCoeffs !== undefined && mangCoeffs.length > 0 ? (
                          <Select
                            className="iq3-detail-select input-editable"
                            value={props.estimateBasicInfo?.estimateProducts?.coeffManagementsId}
                            onChange={async (e) => {
                              const record = mangCoeffs?.find((r) => r.id === e);
                              if (record) {
                                let cpOtherProduct = JSON.parse(
                                  JSON.stringify(props.estimateBasicInfo.estimateProducts.otherProduct)
                                );
                                if (cpOtherProduct) {
                                  cpOtherProduct.coeffManagements = record.coeff;
                                  props.onChangeEstimateProduct({
                                    ...props.estimateBasicInfo.estimateProducts,
                                    coeffManagementsId: record.id,
                                    coeffManagementsName: record.name,
                                    otherProduct: cpOtherProduct,
                                  });
                                }
                              }
                            }}
                            style={{ marginLeft: 5, width: '94%' }}
                          >
                            {mangCoeffs
                              ?.sort((a, b) => Number(a?.sortNum) - Number(b?.sortNum))
                              .map((option, index) => (
                                <Select.Option key={index} value={option.id}>
                                  {option.name}
                                </Select.Option>
                              ))}
                          </Select>
                        ) : (
                          <Select style={{ marginLeft: 5, width: '94%' }} />
                        )}
                      </div>
                    </Col>
                    <Col span={5}>
                      <div style={{ display: 'flex' }}>
                        <Input
                          style={{ padding: 5, marginLeft: 5, width: '94%', backgroundClip: 'text', color: 'white' }}
                          className={'input-non-editable'}
                          name="managementCoefficient"
                          id="managementCoefficient"
                          type="text"
                          value={toDecimal(estimateBasicInfo?.otherProduct?.coeffManagements, 2)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: '5px' }}>
              <Col span={24}>
                <div
                  style={{
                    background: '#364d79',
                    borderRadius: '3px',
                    padding: '3px',
                  }}
                >
                  <Row align="middle">
                    <Col span={7}>
                      <p style={{ margin: 0, fontSize: '12px', paddingLeft: '10px' }}>受注形態</p>
                    </Col>
                    <Col span={12}>
                      <div style={{ display: 'flex' }}>
                        {orderCoeffs !== undefined && orderCoeffs.length > 0 ? (
                          <Select
                            className="iq3-detail-select"
                            value={props.estimateBasicInfo?.estimateProducts?.coeffOrdersId}
                            onChange={async (e) => {
                              const record = orderCoeffs?.find((r) => r.id === e);
                              if (record) {
                                let cpOtherProduct = JSON.parse(
                                  JSON.stringify(props.estimateBasicInfo.estimateProducts.otherProduct)
                                );
                                if (cpOtherProduct) {
                                  cpOtherProduct.coeffOrders = record.coeff;
                                  props.onChangeEstimateProduct({
                                    ...props.estimateBasicInfo.estimateProducts,
                                    coeffOrdersId: record.id,
                                    coeffOrdersName: record.name,
                                    otherProduct: cpOtherProduct,
                                  });
                                }
                              }
                            }}
                            style={{ marginLeft: 5, width: '94%' }}
                          >
                            {orderCoeffs
                              ?.sort((a, b) => Number(a?.sortNum) - Number(b?.sortNum))
                              .map((option, index) => (
                                <Select.Option key={index} value={option.id}>
                                  {option.name}
                                </Select.Option>
                              ))}
                          </Select>
                        ) : (
                          <Select style={{ marginLeft: 5, width: '94%' }} />
                        )}
                      </div>
                    </Col>
                    <Col span={5}>
                      <div style={{ display: 'flex' }}>
                        <Input
                          style={{ padding: 5, marginLeft: 5, width: '94%', backgroundClip: 'text', color: 'white' }}
                          className={'input-non-editable'}
                          name="orderCoefficient"
                          id="orderCoefficient"
                          type="text"
                          value={toDecimal(estimateBasicInfo?.otherProduct?.coeffOrders, 2)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: '5px' }}>
              <Col span={24}>
                <div
                  style={{
                    background: '#364d79',
                    borderRadius: '3px',
                    padding: '3px',
                  }}
                >
                  <Row align="middle">
                    <Col span={7}>
                      <p style={{ margin: 0, fontSize: '12px', paddingLeft: '10px' }}>納期係数</p>
                    </Col>
                    <Col span={12}>
                      <div style={{ display: 'flex' }}>
                        {deliveryDateCoeffs !== undefined && deliveryDateCoeffs.length > 0 ? (
                          <Select
                            className="iq3-detail-select"
                            value={props.estimateBasicInfo?.estimateProducts?.coeffDeliveryDatesId}
                            onChange={async (e) => {
                              const record = deliveryDateCoeffs?.find((r) => r.id === e);
                              if (record) {
                                let cpOtherProduct = JSON.parse(
                                  JSON.stringify(props.estimateBasicInfo.estimateProducts.otherProduct)
                                );
                                if (cpOtherProduct) {
                                  cpOtherProduct.coeffDeliveryDates = record.coeff;
                                  props.onChangeEstimateProduct({
                                    ...props.estimateBasicInfo.estimateProducts,
                                    coeffDeliveryDatesId: record.id,
                                    coeffDeliveryDatesName: record.name,
                                    otherProduct: cpOtherProduct,
                                  });
                                }
                              }
                            }}
                            style={{ marginLeft: 5, width: '94%' }}
                          >
                            {deliveryDateCoeffs
                              ?.sort((a, b) => Number(a?.sortNum) - Number(b?.sortNum))
                              .map((option, index) => (
                                <Select.Option key={index} value={option.id}>
                                  {option.name}
                                </Select.Option>
                              ))}
                          </Select>
                        ) : (
                          <Select style={{ marginLeft: 5, width: '94%' }} />
                        )}
                      </div>
                    </Col>
                    <Col span={5}>
                      <div style={{ display: 'flex' }}>
                        <Input
                          style={{ padding: 5, marginLeft: 5, width: '94%', backgroundClip: 'text', color: 'white' }}
                          className={'input-non-editable'}
                          name="orderCoefficient"
                          id="orderCoefficient"
                          type="text"
                          value={toDecimal(estimateBasicInfo?.otherProduct?.coeffDeliveryDates, 2)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: '5px' }}>
              <Col span={24}>
                <div
                  style={{
                    background: '#364d79',
                    borderRadius: '3px',
                    padding: '3px',
                  }}
                >
                  <Row align="middle">
                    <Col span={7}>
                      <p style={{ margin: 0, fontSize: '12px', paddingLeft: '10px' }}>段取係数</p>
                    </Col>
                    <Col span={12}>
                      <div style={{ display: 'flex' }}>
                        {setupCoeffs !== undefined && setupCoeffs.length > 0 ? (
                          <Select
                            className="iq3-detail-select"
                            value={props.estimateBasicInfo?.estimateProducts?.coeffSetupId}
                            onChange={async (e) => {
                              const record = setupCoeffs?.find((r) => r.id === e);
                              if (record) {
                                let cpOtherProduct = JSON.parse(
                                  JSON.stringify(props.estimateBasicInfo.estimateProducts.otherProduct)
                                );
                                if (cpOtherProduct) {
                                  let coeffVal = 1;
                                  let iq3Count = props.estimateBasicInfo?.esIq3Info?.length;
                                  // 段取個数係数
                                  let prepQtyCoeffTh = record?.setupCoeffThMaster?.filter(
                                    (item) => (item.value == iq3Count || item.value > iq3Count) && !item.isOutOfRange
                                  );
                                  if (prepQtyCoeffTh) {
                                    let prepQtyCoeffThNo =
                                      prepQtyCoeffTh?.length > 0
                                        ? prepQtyCoeffTh?.[0]?.no
                                        : record?.setupCoeffThMaster?.[0]?.no;
                                    let prepQtyCoeff =
                                      prepQtyCoeffThNo == 0
                                        ? 0
                                        : record?.setupCoeffThItems?.filter(
                                            (item) => item.no == prepQtyCoeffThNo && !item.isOutOfRange
                                          )[0]?.value;
                                    coeffVal = prepQtyCoeff;
                                    coeffVal = coeffVal ? coeffVal : 1;
                                    cpOtherProduct.coeffSetups = coeffVal;
                                    props.onChangeEstimateProduct({
                                      ...props.estimateBasicInfo.estimateProducts,
                                      coeffSetupId: record.id,
                                      coeffSetupName: record.name,
                                      otherProduct: cpOtherProduct,
                                    });
                                  }
                                }
                              }
                            }}
                            style={{ marginLeft: 5, width: '94%' }}
                          >
                            {setupCoeffs
                              ?.sort((a, b) => Number(a?.sortNum) - Number(b?.sortNum))
                              .map((option, index) => (
                                <Select.Option key={index} value={option.id}>
                                  {option.name}
                                </Select.Option>
                              ))}
                          </Select>
                        ) : (
                          <Select style={{ marginLeft: 5, width: '94%' }} />
                        )}
                      </div>
                    </Col>
                    <Col span={5}>
                      <div style={{ display: 'flex' }}>
                        <Input
                          style={{ padding: 5, marginLeft: 5, width: '94%', backgroundClip: 'text', color: 'white' }}
                          className={'input-non-editable'}
                          name="setupCoefficient"
                          id="setupCoefficient"
                          type="text"
                          value={toDecimal(estimateBasicInfo?.otherProduct?.coeffSetups, 2)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: '5px' }}>
              <Col span={24}>
                <div
                  style={{
                    background: '#364d79',
                    borderRadius: '3px',
                    padding: '3px',
                  }}
                >
                  <Row align="middle">
                    <Col span={7}>
                      <p style={{ margin: 0, fontSize: '12px', paddingLeft: '10px' }}>購入品係数</p>
                    </Col>
                    <Col span={12}>
                      <div style={{ display: 'flex' }}>
                        {purchaseCoeffs !== undefined && purchaseCoeffs.length > 0 ? (
                          <Select
                            className="iq3-detail-select input-editable"
                            value={props?.estimateBasicInfo?.estimateProducts?.coeffPurchasesId}
                            onChange={async (e) => {
                              const record = purchaseCoeffs?.find((r) => r.id === e);
                              if (record) {
                                let cpOtherProduct = JSON.parse(
                                  JSON.stringify(props.estimateBasicInfo.estimateProducts.otherProduct)
                                );
                                if (cpOtherProduct) {
                                  cpOtherProduct.coeffPurchases = record.coeff;
                                  props.onChangeEstimateProduct({
                                    ...props.estimateBasicInfo.estimateProducts,
                                    coeffPurchasesId: record.id,
                                    coeffPurchasesName: record.name,
                                    otherProduct: cpOtherProduct,
                                  });
                                }
                              }
                            }}
                            style={{ marginLeft: 5, width: '94%' }}
                          >
                            {purchaseCoeffs
                              ?.sort((a, b) => Number(a?.sortNum) - Number(b?.sortNum))
                              .map((option, index) => (
                                <Select.Option key={index} value={option.id}>
                                  {option.name}
                                </Select.Option>
                              ))}
                          </Select>
                        ) : (
                          <Select style={{ marginLeft: 5, width: '94%' }} />
                        )}
                      </div>
                    </Col>
                    <Col span={5}>
                      <div style={{ display: 'flex' }}>
                        <Input
                          style={{ padding: 5, marginLeft: 5, width: '94%', backgroundClip: 'text', color: 'white' }}
                          className={'input-non-editable'}
                          name="orderCoefficient"
                          id="orderCoefficient"
                          type="text"
                          value={toDecimal(estimateBasicInfo?.otherProduct?.coeffPurchases, 2)}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: '5px' }}>
              <Col span={24}>
                <div
                  style={{
                    background: '#364d79',
                    borderRadius: '3px',
                    padding: '3px',
                  }}
                >
                  <Row align="middle">
                    <Col span={7}>
                      <p style={{ margin: 0, fontSize: '12px', paddingLeft: '10px' }}>子部品生産個数係数</p>
                    </Col>
                    <Col span={12}>
                      <div style={{ display: 'flex' }}>
                        {proudCoeffs !== undefined && proudCoeffs.length > 0 ? (
                          <Select
                            className="iq3-detail-select"
                            value={props.estimateBasicInfo?.estimateProducts?.coeffProductId}
                            onChange={async (e) => {
                              const record = proudCoeffs?.find((r) => r.id === e);
                              if (record) {
                                let cpOtherProduct = JSON.parse(
                                  JSON.stringify(props.estimateBasicInfo.estimateProducts.otherProduct)
                                );
                                if (cpOtherProduct) {
                                  cpOtherProduct.coeffProducts = record.coeff;
                                  props.onChangeEstimateProduct({
                                    ...props.estimateBasicInfo.estimateProducts,
                                    coeffProductId: record.id,
                                    coeffProductName: record.name,
                                    otherProduct: cpOtherProduct,
                                  });
                                }
                              }
                            }}
                            style={{ marginLeft: 5, width: '94%' }}
                          >
                            {proudCoeffs
                              ?.sort((a, b) => Number(a?.sortNum) - Number(b?.sortNum))
                              .map((option, index) => (
                                <Select.Option key={index} value={option.id}>
                                  {option.name}
                                </Select.Option>
                              ))}
                          </Select>
                        ) : (
                          <Select style={{ marginLeft: 5, width: '94%' }} />
                        )}
                      </div>
                    </Col>
                    <Col span={5}></Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: '5px' }}>
              <Col span={7}>
                <div>
                  <Row>
                    <Col span={24}>
                      <Button
                        key="grossBtn"
                        type="primary"
                        onClick={openMGrossProfitCoeff}
                        className="grossProfitCoeffBtn"
                      >
                        材料粗利係数
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Card>
          {/** コメント */}
          <Card hoverable={false} style={{ borderTop: '1px solid #ffffff' }}>
            <Row>
              <Col span={24}>
                <p style={{ margin: 0, fontSize: '12px' }}>コメント</p>
              </Col>
            </Row>
            <Row style={{ marginTop: '5px' }}>
              <Col span={24}>
                {/* 2025-05-15 数量や粗利係数などを直接左側の画面から変更できない。 */}
                {/* <p style={{ margin: 0, fontSize: '12px' }}>{estimateBasicInfo?.comment}</p> */}
                <TextArea
                  style={{
                    verticalAlign: 'Top',
                    fontSize: '12px',
                    height: '130px',
                    borderRadius: '5px',
                    padding: '10px',
                    // color: 'white',
                  }}
                  // className={'input-non-editable'}
                  name="comment"
                  id="comment"
                  value={estimateBasicInfo?.comment}
                  type="text"
                  rows={5}
                  onChange={(e) => {
                    setEstimateBasicInfo({
                      ...estimateBasicInfo,
                      comment: e.target.value,
                    });
                    props.onChangeEstimateProduct({
                      ...props.estimateBasicInfo.estimateProducts,
                      comment: e.target.value,
                    });
                  }}
                />
              </Col>
            </Row>
          </Card>

          {/** 新旧パラで計算のメッセージ表示 */}
          {isReCalOldNewParam
            ? commonModal(
                isReCalOldNewParam,
                confirmScreenChangeTitle,
                null,
                null,
                400,
                calculateWithNewParam,
                discardConfirmCancel,
                confirmDisplayOldNewParamContent(calculateWithNewParam, calculateWithOldParam, discardConfirmCancel),
                null,
                null,
                false
              )
            : ''}

          {/** 材料粗利係数のメッセージ表示 */}
          {isMGrossProfitCoeff
            ? commonModal(
                isMGrossProfitCoeff,
                mGrossProfitCoeffTitle,
                null,
                null,
                850,
                null,
                closeMGrossProfitCoeff,
                mGrossProfitCoeffContent,
                null,
                null,
                false
              )
            : ''}

          {customerModal ? (
            <SearchAndGetCustomerData
              customerModal={customerModal}
              selectedCustomerData={selectedCustomerData}
              title={Customer}
              clientType={ClientType.Customer}
              closeCustomerModal={closeCustomerModal}
              selectedEstimateData={props.estimateBasicInfo?.estimateProducts}
            />
          ) : (
            ''
          )}
        </div>
      ) : (
        ''
      )}
    </>
  );
});

export default EstimateBasicInfo;
